var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { HubPlace } from '../../../../models/hub/hub.place';
import { ImageService } from '../../../../services/image.service';
import { PlaceDetailsModalComponent } from 'components/visitor/place.details.modal/place.details.modal.component';
import { PlaceDetailsModalActions } from '../../place.details.modal/place.details.modal.provider';
import { TripDetailModalActions, TripDetailModalData } from '../../trip/trip.detail.modal/trip.detail.modal.provider';
import { TripDetailModalComponent } from '../../trip/trip.detail.modal/trip.detail.modal.component';
import { EditorChoiceStore } from '../../../../stores/hub.calendar.store';
import { PlaceService } from '../../../../services/place.service';
var VisitorPlaceCardComponent = /** @class */ (function (_super) {
    __extends(VisitorPlaceCardComponent, _super);
    function VisitorPlaceCardComponent(router, imageService, modalService, editorChoiceStore, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.imageService = imageService;
        _this.modalService = modalService;
        _this.editorChoiceStore = editorChoiceStore;
        _this.activatedRoute = activatedRoute;
        _this.editorChoiceText = '';
        return _this;
    }
    VisitorPlaceCardComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.editorChoiceTextHandler();
    };
    VisitorPlaceCardComponent.prototype.showReadable = function (code) {
        return PlaceService.allToReadableCategory(code);
    };
    VisitorPlaceCardComponent.prototype.editorChoiceTextHandler = function () {
        var _this = this;
        this.editorChoiceStore.infoCommand.takeUntil(this.isDestroyed).subscribe(function (editorChoice) {
            _this.editorChoiceText = editorChoice.editorChoiceForPlace;
        });
    };
    VisitorPlaceCardComponent.prototype.enterItemByKeyboard = function ($event) {
        if ($event && $event.key === 'Enter') {
            this.showDetails();
        }
    };
    VisitorPlaceCardComponent.prototype.showDetails = function () {
        if (this.place.isPromotionImage) {
            window.open(this.place.promotionLink, '_blank');
            return;
        }
        if (!this.isMobile) {
            var actions = {
                confirm: function (event, data) {
                },
            };
            this.modalService.show({
                component: PlaceDetailsModalComponent,
                providers: [
                    { provide: PlaceDetailsModalActions, useValue: actions },
                    { provide: HubPlace, useValue: this.place },
                ],
                panelClass: 'modal-fixed-top',
            });
        }
        else {
            this.showDetailModalForMobile(this.place, 'place');
            //     let {hubName, category, menuType} = this.allRouteParams;
            //     category = PlaceCategory.getPlaceCategoryKey(category);
            //     this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeDetails,
            //         {
            //             hubName,
            //             placeId: this.place._id,
            //             category: category,
            //             menuType: menuType
            //         }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
    };
    VisitorPlaceCardComponent.prototype.showDetailModalForMobile = function (item, displayingOn, isShowAddToTripBtn, index) {
        if (isShowAddToTripBtn === void 0) { isShowAddToTripBtn = false; }
        var actions = {
            confirm: function (event) {
            },
        };
        this.modalService.show({
            component: TripDetailModalComponent,
            providers: [
                { provide: TripDetailModalActions, useValue: actions },
                {
                    provide: TripDetailModalData,
                    useValue: new TripDetailModalData(item, displayingOn, this.hubName, null, null, isShowAddToTripBtn, index),
                },
            ],
            panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
        });
    };
    VisitorPlaceCardComponent.prototype.remove = function () {
    };
    return VisitorPlaceCardComponent;
}(BaseComponent));
export { VisitorPlaceCardComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/place.card/visitor.place.card.component.ts.pre-build-optimizer.js